import { Container, IDestroyOptions, Sprite, TextStyle, Text } from "pixi.js";
import { HourlyBonusResourcePackage } from "../../resources/HourlyBonusResourcePackage";
import { GameFont } from "../../../../../common/GameFont";
import { XMoreAnimation } from "./XMoreAnimation";
import { ICanvasScaler } from "by/gamefactory/canvas/ICanvasScaler";
import { SoundsResourcePackageWrapper } from "../../../../../common/resources/SoundsResourcePackageWrapper";

export class XMoreContainer extends Container {
    private static readonly X_4_MORE = "X4 MORE";

    private readonly wheelResources: HourlyBonusResourcePackage;
    private readonly soundResources: SoundsResourcePackageWrapper;
    private readonly canvasScaler: ICanvasScaler;
    private xMoreBg: Sprite;
    private xMoreBgLight: Sprite;
    private shaderAnimation: XMoreAnimation;

    public constructor(
        wheelResources: HourlyBonusResourcePackage,
        soundResources: SoundsResourcePackageWrapper,
        canvasScaler: ICanvasScaler
    ) {
        super();
        this.wheelResources = wheelResources;
        this.soundResources = soundResources;
        this.canvasScaler = canvasScaler;
        this.build();
    }

    private build(): void {
        this.xMoreBg = new Sprite(this.wheelResources.assets_views_hourly_bonus_golden_wheel_bg_for_x_more_png);
        this.xMoreBg.anchor.set(0.5);
        this.addChild(this.xMoreBg);
        const xMoreText = new Text(XMoreContainer.X_4_MORE, new XMoreTextStyle());
        xMoreText.anchor.set(0.5);
        xMoreText.skew._x = -0.087;
        xMoreText.angle = -5;
        this.xMoreBg.addChild(xMoreText);
        this.xMoreBgLight = new Sprite(this.wheelResources.assets_views_hourly_bonus_golden_wheel_light_yellow_png);
        this.xMoreBgLight.anchor.set(0.5);
        this.xMoreBgLight.position.y = this.xMoreBg.height * 0.8;
        this.addChild(this.xMoreBgLight);
        this.shaderAnimation = new XMoreAnimation(this.canvasScaler);
        this.addChild(this.shaderAnimation);
    }

    public playGlowAnimation(): void {
        this.soundResources.assets_sounds_goldenwheel_new_wheel_4x_more_appear_v2_mp3.play();
        this.shaderAnimation.play();
    }

    public hideGlow(): void {
        this.shaderAnimation.visible = false;
    }

    public override destroy(options?: boolean | IDestroyOptions): void {
        super.destroy(options);
    }
}

class XMoreTextStyle extends TextStyle {
    public constructor() {
        super(new TextStyle({
            align: "center",
            fill: "#ffffff",
            fontFamily: GameFont.DEFAULT_FONT,
            fontSize: 160,
            leading: 10
        }));
    }
}